exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.subOption[data-v-1062f3f1] {\n  font-size: 14px;\n}\n.disablecolor[data-v-1062f3f1] {\n  color: #6d6d72;\n}\n.subOption input[data-v-1062f3f1]::-webkit-input-placeholder {\n  font-size: 14px;\n}\n.label-switch[data-v-1062f3f1] {\n  float: right;\n}\nul[data-v-1062f3f1] {\n  margin-left: -35px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1062f3f1","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/settings/CMDirectPaymentsSettingsPage.vue
// module id = 1530
// module chunks = 2